import { render, staticRenderFns } from "./veStuLeaveEdit.vue?vue&type=template&id=c06e0888&scoped=true"
import script from "./veStuLeaveEdit.vue?vue&type=script&lang=js"
export * from "./veStuLeaveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e0888",
  null
  
)

export default component.exports